// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonActionNotDoneYet_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.9607 14.4994C21.8933 11.1519 20.7464 6.87151 17.3989 4.93883C14.0514 3.00616 9.77101 4.1531 7.83834 7.50058C7.37904 8.29612 7.09367 9.14434 6.97043 10.0012H8.99956C9.18805 9.07138 9.64285 8.18478 10.364 7.46365C12.3166 5.51103 15.4824 5.51103 17.435 7.46365C19.3877 9.41628 19.3877 12.5821 17.435 14.5347C16.7147 15.255 15.8293 15.7096 14.9006 15.8985V17.9272C16.9488 17.6298 18.8455 16.4309 19.9607 14.4994Z" class="svg-bg"/>
  <path d="M14.6066 10.2921L11.7782 18.7774L9.65685 16.656L5.41421 20.8987L4 19.4845L8.24264 15.2418L6.12132 13.1205L14.6066 10.2921Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonActionNotDoneYet is a generated icon component.
 */
let IconCommonActionNotDoneYet = IconCommonActionNotDoneYet_1 = class IconCommonActionNotDoneYet extends IconBaseElement {
    render() {
        return html `${IconCommonActionNotDoneYet_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonActionNotDoneYet.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonActionNotDoneYet = IconCommonActionNotDoneYet_1 = __decorate([
    customElement('zui-icon-common-action-not-done-yet')
], IconCommonActionNotDoneYet);
export { IconCommonActionNotDoneYet };
